const ActionFactory = actionTypeName => ({
  REQUEST: `${actionTypeName}_REQUEST`,
  SUCCESS: `${actionTypeName}_SUCCESS`,
  FAILURE: `${actionTypeName}_FAILURE`,
});

module.exports = ActionFactory;



// WEBPACK FOOTER //
// ./src/actions/ActionFactory.js